export default {
  images: {
    items: {
      'ui:widget': 'EditorUploadWidget',
    },
  },
}
